import React, { useEffect } from "react";
import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import Add from "./New";
import EditMembers from "./Edit";
// import Careers from "./List";

import EditModule from "./Edit";
import ListModule from "./List/List";
import Deta from "./List/DetailViewModal";
import DetailsModule from "./Details";
import SubSidebar from "../../layout/components/SubSidebar/SubSidebar";
import DetailView from "../../layout/components/DetailView/DetailView";
import EditSubSidebar from "./Edit/EditSubSidebar";

function CRUDModule(props: any) {
  useEffect(() => {
    console.log("props.module", props.module);
    console.log("props.primary_key", props.primary_key);
  }, [props.module, props.primary_key]); // Reacts to module prop changes
  return (
    <Routes>
      <Route
        element={
          <>
            <Outlet />
          </>
        }
      >
        <Route
          path="*"
          element={
            <>
              <ListModule
                module={props.module}
                primary_key={props.primary_key}
              />
            </>
          }
        />
        <Route
          path="list"
          element={
            <>
              <ListModule
                module={props.module}
                primary_key={props.primary_key}
              />
            </>
          }
        />
        <Route
          path="new"
          element={
            <>
              <Add module={props.module} primary_key={props.primary_key} />
            </>
          }
        />
        <Route
          path="edit/:id"
          element={
            props.module === "admin_user_roles" ? (
              <EditSubSidebar module={props.module} primary_key={props.primary_key} />
            ) : (
              <EditModule module={props.module} primary_key={props.primary_key} />
            )
          }
        />
        {/* <Route
          path="edit/:id"
          element={
            <>
              <EditModule
                module={props.module}
                primary_key={props.primary_key}
              />
            </>
          }
        /> */}
        {/* <Route
          path="details/:id"
          element={
            <>
              <DetailsModule
                module={props.module}
                primary_key={props.primary_key}
              />
            </>
          }
        /> */}
        <Route
          path="details/:id"
          element={
            props.module === "app_clients" ? (
              <SubSidebar module={props.module} primary_key={props.primary_key} />
            ) : (
              // <DetailsModule module={props.module} primary_key={props.primary_key} />
              <DetailView module={props.module} primary_key={props.primary_key} />
            )
          }
        />

        {/* <Route index element={<Navigate to="/career_enquiry/list" />} /> */}
      </Route>
    </Routes>
  );
}

export default CRUDModule;
